import { render, staticRenderFns } from "./TransferSku.vue?vue&type=template&id=0ca143c1&"
import script from "./TransferSku.vue?vue&type=script&lang=js&"
export * from "./TransferSku.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports